import GeneratorCard from "./GeneratorCard";
import { generatorCardsConfig } from "../config/generatorsConfig";

const Generators = () => {
  return (
    <div className="bg-black w-full h-full flex flex-col">
      <div className="h-min flex items-center justify-center p-1">
        <h2 className="text-lg 2xl:text-2xl font-bold">Generators</h2>
      </div>
      <div className="flex-1 min-h-0 h-full">
        <div className="h-full w-full pb-2 pt-0 2xl:pt-2 px-6 2xl:px-4 flex justify-between">
          {generatorCardsConfig.map((item, index) => {
            return (
              <GeneratorCard generatorItem={item} key={index} />
            );
          })}
        </div>
      </div>
    </div >
  );
};

export default Generators;